import { defineStore } from 'pinia'
import { LocalStorage } from 'quasar'
import { getAllStoresForReset } from '../index.js'

const useGlobalStore = defineStore('global', {
  state: () => ({
    modals: {},
    search: ''
  }),
  actions: {
    logout() {
      LocalStorage.remove('gql_access_token')
      LocalStorage.remove('access_token')
      LocalStorage.remove('currentUser')

      // Reset all stores dynamically
      this.resetAllStores()

      // Reset global state
      this.$patch({
        modals: {},
        search: ''
      })
    },
    resetAllStores() {
      const stores = getAllStoresForReset()
      stores.forEach(useStore => {
        const storeInstance = useStore()
        if (typeof storeInstance.$reset === 'function') {
          storeInstance.$reset()
        }
      })
    },
    setSearch(search) {
      this.search = search
    },
    openModal(modal) {
      this.modals[modal] = true
    },
    closeModal(modal) {
      this.modals[modal] = false
    }
  },
  getters: {
    getSearch: (state) => state.search
  }
})

export default useGlobalStore
